export default __webpack_public_path__ + "static/media/review_admin.98c34324.svg";